export default __webpack_public_path__ + "static/mittagsangebote-eb112359fbf0a5b50e829b949c9d1f0f.jpg";